<div id="background-check" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Contact Information</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/basic" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Personal Information</h2>
              <p>Driver’s license, social security, marital status, children and pets</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/personal" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Residency History</h2>
              <p>Two years of residency history information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/residency" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Employment Information</h2>
              <p>Two years of employment information</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div *ngIf="verifastEnabled" class="flex flex-row box-border-inactive pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Income & Identity</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/verifast" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Verify Income</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/documents" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Background Check</h2>
              <p>You have agreed to the Terms and Conditions</p>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-right"
                routerLink="/application/background-check" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex flex-row box-border-inactive pb-4">
          <div *ngIf="!verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div *ngIf="verifastEnabled" class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">8/{{totalApplicationSteps}}</h2>
          </div>
          <div class="flex flex-col sm:w-full sm:flex-row sm:justify-between">
            <div class="col-span-6">
              <h2 class="text-lg font-bold mt-6 mb-2 sm:my-6">Additional Applicants</h2>
            </div>
            <div class="col-span-3 sm:text-right">
              <button mat-flat-button color="accent" class="h-10 px-6 mt-2 sm:mt-6 text-righ"
                routerLink="/application/applicants" routerLinkActive="active">UPDATE</button>
            </div>
          </div>
        </div>
        <div class="flex box-border-active pb-4">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">{{currentApplicationStep}}/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Rentable Items and Services</h2>
            <p>Are you interested in any of the following rentable items or services? <br>A leasing agent will get back
              to you to confirm details, charges are applied at time of lease.</p>
            <div *ngIf="errorMessage!=null" class="alert alert-danger">
              {{ errorMessage }}
            </div>
          </div>
        </div>
      </div>

      <div class="pt-2">
        <form id="rentablesForm" #rentablesForm="ngForm" class="flex flex-col pt-8" style="position: relative;">
          <div *ngIf="isLoading" class="spinner flex flex-col">
            <mat-spinner></mat-spinner>
          </div>
          <div *ngIf="showServiceFees" matTooltip="{{ serviceFeesToolTip }}" matTooltipPosition="left" class="md:flex md:items-center">
            <div class="md:w-1/2 md:pr-2">
              <div class="w-full my-2">
                <mat-checkbox  matInput
                    name="ServiceFee"
                    id="ServiceFee"
                    [(ngModel)]="selectedServiceFee"
                    #IsSelected="ngModel"
                    [disabled]="true"
                    binary="true"
                    required>
                </mat-checkbox>
                Services and Amenities (mandatory)
              </div>
            </div>
            <div class="md:w-1/2 md:pr-2">
              <div class="w-full my-2">
                ${{ serviceFees | number: '1.2-2' }}/mo
              </div>
            </div>
          </div>
        <div *ngFor="let rentableItem of rentableItems; let i = index; trackBy:listTrack; first as isFirst">
          <div>
            <div *ngIf="rentableItem.showLineItem" matTooltip="{{ rentableItem.Description }}" matTooltipPosition="left" class="md:flex md:items-center">
              <div class="md:w-1/2 md:pr-2">
                <div class="w-full my-2">
                  <mat-checkbox  matInput
                    name="IsSelected[{{i}}]"
                    id="IsSelected[{{i}}]"
                    [(ngModel)]="rentableItem.IsSelected"
                    #IsSelected="ngModel"
                    [disabled]="rentableItem.Required || !primaryApplicant || rentableItem.DisableTestableItem"
                    binary="true" (change)="onRentableItemChange($event, rentableItem)"
                    required>
                  </mat-checkbox>
                  {{ rentableItem.Type }}
                  <span *ngIf="rentableItem.Required">
                    (mandatory)
                  </span>
                </div>
              </div>

              <div class="md:w-1/2 md:pr-2">
                <div class="w-full my-2">
                  ${{ rentableItem.Cost | number: '1.2-2'  }}/mo
                </div>
              </div>
            </div>
          </div>
        </div>
          <div *ngFor="let ancillaryItem of AncillaryItems; let i = index; trackBy:listTrack; first as isFirst">
            <div>
              <ng-template #tooltipTpl style="max-width: 360px;">
                <div [innerHTML]=ancillaryItem.Description class="tooltiptext"></div>
              </ng-template>
              <div [mtxTooltip]="tooltipTpl" [mtxTooltipPosition]="position" class="md:flex md:items-center">
                <div class="md:w-1/2 md:pr-2">
                  <div class="w-full my-2">
                    <mat-checkbox
                      matInput
                      name="IsAniSelected[{{i}}]"
                      id="IsAniSelected[{{i}}]"
                      [(ngModel)]="ancillaryItem.IsSelected"
                      #IsSelected="ngModel"
                      [disabled]="ancillaryItem.IsDisabled || isLoading"
                      binary="true" (change)="onAncillaryItemChange($event, ancillaryItem)"
                      required></mat-checkbox>
                    {{ ancillaryItem.Name }}
                    <span *ngIf="ancillaryItem.IsRequired">
                      (mandatory)
                    </span>
                  </div>
                </div>
                <div class="md:w-1/2 md:pr-2">
                  <div class="w-full my-2">
                    ${{ ancillaryItem.Cost | number: '1.2-2' }}/mo
                  </div>
                </div>
              </div>
            </div>
          </div>
        <div class="md:flex w-full sm:justify-left pt-5">
          Total: ${{ (rentablesCost + aniCost) | number: '1.2-2' }}
        </div>
        <div class="md:flex">
          <div class="text-right w-full" style="margin-top: 10px">
            <button mat-flat-button color="primary" [disabled]="isLoading" (click)="onSubmit()" class="h-10 px-6 my-2">CONTINUE</button>
          </div>
        </div>
      </form>
      </div>
    </div>
  </div>
</div>
